import React, { useState, useEffect } from 'react';
import { 
    Button, 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    List, 
    ListItem, 
    ListItemIcon, 
    ListItemText, 
    Checkbox,
    Box,
    Typography
} from '@material-ui/core';
import { Send, FiberManualRecord } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

export default function ChecklistDialog({
    open,
    onClose,
    items = [],
    onSave,
    title = "Checklist",
    confirmText = "I confirm that I have reviewed all items listed above and completed the required service steps in full.",
    sendButtonLabel = "Send to Center",
    cancelButtonLabel = "Cancel"
}) {
    const [confirmed, setConfirmed] = useState(false);
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        if (open) {
            setConfirmed(false);
            setShowWarning(false);
        }
    }, [open]);

    const handleOk = () => {
        if (!confirmed) {
            setShowWarning(true);
            return;
        }

        if (onSave) {
            onSave([]);
        }
        onClose();
    };

    return (
        <Dialog
            maxWidth="sm"
            fullWidth
            open={open}
            onClose={onClose}
        >
            <DialogTitle>{title}</DialogTitle>

            <DialogContent dividers>
                {showWarning && (
                    <Box mb={2}>
                        <Alert severity="warning">
                            Please confirm that you have reviewed all items before sending to center.
                        </Alert>
                    </Box>
                )}
                <List>
                    {items.map((item) => {
                        return (
                            <ListItem key={item.id} dense>
                                <ListItemIcon style={{ minWidth: 35 }}>
                                    <Typography variant="body2">
                                        {item.id}
                                    </Typography>
                                </ListItemIcon>
                                <ListItemText 
                                    primary={item.label} 
                                />
                            </ListItem>
                        );
                    })}
                </List>
            </DialogContent>

            <DialogActions>
                <Box display="flex" flexDirection="column" width="100%" p={2}>
                    <Box mb={2}>
                        <ListItem dense>
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={confirmed}
                                    onChange={(e) => {
                                        setConfirmed(e.target.checked);
                                        setShowWarning(false);
                                    }}
                                    color="primary"
                                />
                            </ListItemIcon>
                            <ListItemText 
                                primary={
                                    <Typography variant="body2" style={{ fontWeight: 500 }}>
                                        {confirmText}
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </Box>
                    <Box display="flex" justifyContent="flex-end" style={{ gap: 8 }}>
                        <Button onClick={onClose} color="default">
                            {cancelButtonLabel}
                        </Button>
                        <Button
                            onClick={handleOk}
                            variant="contained"
                            color="primary"
                            disabled={!confirmed}
                            endIcon={<Send />}
                        >
                            {sendButtonLabel}
                        </Button>
                    </Box>
                </Box>
            </DialogActions>
        </Dialog>
    );
}